

export function mobileButton1_click(event) {
	if($w('#answerInput').value === '1375'){
		$w('#mobileText1').hide()
		$w('#mobileImage1').hide()
		$w('#answerInput').hide()
		$w('#mobileButton1').hide()
		$w('#mobileImage2').show()
	}
	else{
		$w('#mobileText2').show()
		setTimeout(()=> {
			$w('#mobileText2').hide()
		}, 1000)
	}
}